var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3381 4.25C25.1297 4.25 31.5047 9.32167 31.5047 15.5833C31.5047 21.845 25.1297 26.9167 17.3381 26.9167C15.5814 26.9167 13.8956 26.6617 12.3372 26.2083C8.20055 29.75 3.17139 29.75 3.17139 29.75C6.47222 26.4492 6.99639 24.225 7.06722 23.375C4.65889 21.3492 3.17139 18.6008 3.17139 15.5833C3.17139 9.32167 9.54639 4.25 17.3381 4.25Z",
    fill: "#B22539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover3);
export default __webpack_public_path__ + "static/media/discover3.4c298e94a6837ddda0420c8e3c607b6b.svg";
export { ForwardRef as ReactComponent };